import { users_me_route, VITE_API_URL } from "@/constants";
import type { AuthFetchParams } from "./global";
import { queryOptions } from "@tanstack/react-query";
import type { User } from "@/lib/types";

export async function getCurrentUser(params: AuthFetchParams) {
  const res = await fetch(`${VITE_API_URL}${users_me_route}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.token}`,
      "X-Inventoree-Organization": params.orgId,
    },
    credentials: "include",
  });

  const access = res.headers.get("access-token");
  if (access) params.setToken(access);

  return (await res.json()) as User;
}

export const currentUserQueryOpts = (params: AuthFetchParams) =>
  queryOptions({
    queryKey: ["user", "me"],
    queryFn: async () => await getCurrentUser(params),
    staleTime: 15 * 60 * 1000, // 15 minutes
  });
